import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide"]
  static values = { 
    autoplay: { type: Boolean, default: true },
    interval: { type: Number, default: 5000 }
  }

  connect() {
    this.index = 0
    this.showSlide(this.index)
    
    if (this.autoplayValue) {
      this.startAutoplay()
    }
  }

  disconnect() {
    this.stopAutoplay()
  }

  next() {
    this.stopAutoplay()
    this.index = (this.index + 1) % this.slideTargets.length
    this.showSlide(this.index)
    if (this.autoplayValue) {
      this.startAutoplay()
    }
  }

  previous() {
    this.stopAutoplay()
    this.index = (this.index - 1 + this.slideTargets.length) % this.slideTargets.length
    this.showSlide(this.index)
    if (this.autoplayValue) {
      this.startAutoplay()
    }
  }

  goToSlide(event) {
    this.stopAutoplay()
    this.index = parseInt(event.currentTarget.dataset.index)
    this.showSlide(this.index)
    if (this.autoplayValue) {
      this.startAutoplay()
    }
  }

  showSlide(n) {
    this.slideTargets.forEach((slide, i) => {
      if (i === n) {
        slide.classList.remove('hidden', 'opacity-0')
        slide.classList.add('opacity-100')
      } else {
        slide.classList.remove('opacity-100')
        slide.classList.add('hidden', 'opacity-0')
      }
    })

    // Update dots
    const dots = this.element.querySelectorAll('[data-index]')
    dots.forEach((dot, i) => {
      if (i === n) {
        dot.classList.remove('bg-white', 'bg-opacity-50')
        dot.classList.add('bg-white', 'bg-opacity-100')
      } else {
        dot.classList.remove('bg-opacity-100')
        dot.classList.add('bg-opacity-50')
      }
    })
  }

  startAutoplay() {
    this.autoplayTimer = setInterval(() => {
      this.index = (this.index + 1) % this.slideTargets.length
      this.showSlide(this.index)
    }, this.intervalValue)
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer)
    }
  }
}

